import { Component, OnInit, Output, Input, ViewChild, EventEmitter } from '@angular/core';

import { DropdownValue } from './dropdown.model';
import { DropdownComponent } from './dropdown.component';
import { FilterItemsService } from './filter-items.service';

@Component({
    selector: 'publisher-group-selection',
    template: `<dropdown class="configurable-dropdown" #selector 
    [values]="publisherGroupValues" 
    [prefix]="publisherGroupPrefix" 
    (valueChange)="onPublisherGroupValueChanged($event)" 
    [useLightClass]="useLightClass"></dropdown>`
})
export class PublisherGroupSelectionComponent implements OnInit {
    publisherGroupValues: Array<DropdownValue> = [];
    defaultPublisherSelection: DropdownValue;
    publisherGroupPrefix: string = "Group";

    @Input()
    useLightClass: boolean = false;

    @Input()
    addAllSelection: boolean = false;

    @Output()
    public publisherGroupChange: EventEmitter<DropdownValue> = new EventEmitter<DropdownValue>();;

    @ViewChild("selector") dropdownComponent: DropdownComponent;

    constructor(private filterItemsService: FilterItemsService) {
    }

    ngOnInit() {
        let groups = this.filterItemsService.getPublisherGroups();
        if (groups.length > 0 && this.addAllSelection)
            this.publisherGroupValues.push(new DropdownValue(0, 'All'));

        for (let group of groups)
            this.publisherGroupValues.push(new DropdownValue(group.id, group.name));
    }

    onPublisherGroupValueChanged(item: DropdownValue) {
        this.publisherGroupChange.emit(item);
    }

    setCurrentSelection(id: number) {
        let groupValue = this.publisherGroupValues.find(s => s.value === id);
        if (groupValue)
            this.dropdownComponent.setCurrentSelection(groupValue);
    }

    getItem(id: number): DropdownValue {
        return this.publisherGroupValues.find(s => s.value === id);
    }

    setFirstItem(): DropdownValue {
        if (this.publisherGroupValues.length > 0) {
            this.dropdownComponent.setCurrentSelection(this.publisherGroupValues[0]);
            return this.publisherGroupValues[0];
        }
        return null;
    }

    loadItems(includeItems: Array<number>, noDefaultSelection: boolean = false) {
        this.publisherGroupValues.splice(0);
        let groups = this.filterItemsService.getPublisherGroups();
        if (groups.length > 0 && this.addAllSelection)
            this.publisherGroupValues.push(new DropdownValue(0, 'All'));

        if (!includeItems)
            for (let i = 0; i < groups.length; i++)
                this.publisherGroupValues.push(new DropdownValue(groups[i].id, groups[i].name));
        else
            for (let i = 0; i < groups.length; i++)
                if ($.inArray(groups[i].id, includeItems) > -1)
                    this.publisherGroupValues.push(new DropdownValue(groups[i].id, groups[i].name));

        if (this.publisherGroupValues.length > 0 && noDefaultSelection == false)
            this.dropdownComponent.setCurrentSelection(this.publisherGroupValues[0]);
        else
            this.dropdownComponent.setCurrentSelection(null);           
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/publisher-group-selection.component.ts